import { Outlet, NavLink } from "react-router-dom";
import Seo from './Seo'
// import { useSelector, useDispatch } from 'react-redux';
// import { ChangeByPayload } from '../store/ActiveLinkLogic';

import ImgFb from '../img/img_fb.jpg';

const BlogPage = () => {
return(
<>
<Seo
title="Blog Creativo | Articoli e Curiosità sul Design"
description="Esplora articoli, approfondimenti e curiosità sul mondo creativo. Scopri i segreti della tipografia, le tendenze del logo design e i migliori annunci pubblicitari dal mondo."
keywords="blog creativo, articoli tipografia, logo design, pubblicità internazionali, giralda design"
url="https://giralda-design.web.app/blog"
immagine={ImgFb}
></Seo>

<Outlet></Outlet>
</>   
)};

export default BlogPage;